import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from '../userContext';

import SettingsSidebar from '../partials/settings/SettingsSidebar';
import Profile from './Profile';
import Company from './Company';
import Plans from './Plans'; // Import the Plans component
import Users from './Users';


function Settings() {
  const [planRedirectLoading, setPlanRedirectLoading] = useState(false);
  const { subscriptionType } = useUser();

  return (
    <div className="max-w-7xl mx-auto" style={{fontFamily: '"Share Tech Mono", monospace'}}>
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-black tracking-wider flex items-center gap-3" style={{
          color: '#F1C40F',
          textShadow: '2px 2px 0px #E67E22, 4px 4px 0px #D35400',
          WebkitTextStroke: '1px #E67E22'
        }}>
          SETTINGS
        </h1>
        <p className="text-sm mt-2 font-bold" style={{color: '#ECF0F1'}}>
          Configure your account and preferences
        </p>
      </div>

      <div className="studio-card rounded-xl mb-8">
        <div className="flex flex-col md:flex-row md:-mr-px">
          <SettingsSidebar />
          <Routes>
            <Route path="account" element={<Profile />} />
            <Route path="company" element={<Company />} />
            <Route path="plans" element={   <Plans
              onNext={() =>{}}
              setPlanRedirectLoading={setPlanRedirectLoading}
            />} /> 
            <Route 
              path="users" 
              element={
                subscriptionType === 'agency' 
                  ? <Users /> 
                  : <Navigate to="/studio/settings/plans" replace />
              } 
            />

          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Settings;
